import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DebugPanel from './components/DebugPanel';
import { StudyView } from './components/StudyView';
import { AdminView } from './components/AdminView';
import { ProtectedRoute } from './components/ProtectedRoute';
import AuthPage from './components/AuthPage';
import { useAppStore } from './stores/appStore';
import { useAuthStore } from './stores/authStore';

// Main App component (v2.2.0) - React Router + Zustand + React Query + Authentication
function App() {
  const { debugMode } = useAppStore();
  const { initializeAuth } = useAuthStore();

  // Initialize authentication on app startup
  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  return (
    <div>
      <Routes>
        {/* Public Routes */}
        <Route path='/login' element={<AuthPage />} />
        <Route path='/register' element={<AuthPage />} />

        {/* Protected Routes */}
        <Route path='/' element={<ProtectedRoute />}>
          <Route index element={<Navigate to='/dashboard' replace />} />
          <Route path='dashboard' element={<StudyView />} />
          <Route path='admin' element={<AdminView />} />
        </Route>

        {/* Fallback Route */}
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>

      {/* Global Debug Panel */}
      {debugMode && <DebugPanel />}
    </div>
  );
}

export default App;
